import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5a032308 = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _4c4bc9f6 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _7d99df46 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _09999dc7 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _3cd789c2 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _98c909b0 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _44ae42ae = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _a4c69796 = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _1656ecab = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _740e144b = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _c0590e7a = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _3c613e0d = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _5134aebe = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _ec1eb020 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _2446f0a6 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _393b7026 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _7dbdcc85 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _df105d4a = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _07d6fda6 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _3f242090 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _55dc919d = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _a8f56bea = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _3bd29780 = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _487512a9 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _8b566958 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _321ffaee = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _0e94e4df = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _112781f9 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _46688a50 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _06df7434 = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _5212d29d = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _c2c871ae = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _6ebbae14 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _9f237d38 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _6f7b69f8 = () => interopDefault(import('../../../pages/admin/offers/index.vue' /* webpackChunkName: "pages/admin/offers/index" */))
const _01ea4f6f = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _31e8680a = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _5c4abc38 = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _4b2beafe = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _b7f9a9d2 = () => interopDefault(import('../../../pages/offers/constants/index.js' /* webpackChunkName: "pages/offers/constants/index" */))
const _28919534 = () => interopDefault(import('../../../pages/offers/enums/index.js' /* webpackChunkName: "pages/offers/enums/index" */))
const _7ba52825 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _412af39e = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _e588801e = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _0e6e9c8c = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _30a8dcd1 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _1b1fdee8 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _550d35a1 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _d81b1ed2 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _425ef89c = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _68ddbe6a = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _76e2e64c = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _196434fe = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _5db398cf = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _493856a7 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _7b670426 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _2f994e04 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _94f78e6a = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _faa1e606 = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _0966fdd2 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _3a626764 = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _c7f91702 = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _617fdfd4 = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _5da1b3c1 = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _218d5557 = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _247e2b72 = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _8d8e09e2 = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _1f28ee72 = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _37e2a1b7 = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _855122f6 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _2248b157 = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _4f088b00 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _418bef49 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _0866ff8f = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _24805ffb = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _32416526 = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _d8ab2cd0 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _2ed39b27 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _37992f2e = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _c0529152 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _4f6eba07 = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _69fa3600 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _15703738 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _68aa64c4 = () => interopDefault(import('../../../pages/offers/_id/agreement/index.vue' /* webpackChunkName: "pages/offers/_id/agreement/index" */))
const _c92e91b6 = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _d6068062 = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _ae6971ac = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _13a45b3a = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _e3b3e538 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _5a032308,
    name: "404-error"
  }, {
    path: "/app",
    component: _4c4bc9f6,
    name: "app"
  }, {
    path: "/buy-sell-your-home",
    component: _7d99df46,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _09999dc7,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _3cd789c2,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _98c909b0,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _44ae42ae,
    name: "comparables"
  }, {
    path: "/contact",
    component: _a4c69796,
    name: "contact"
  }, {
    path: "/faq",
    component: _1656ecab,
    name: "faq"
  }, {
    path: "/favourites",
    component: _740e144b,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _c0590e7a,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _3c613e0d,
    name: "listing-management"
  }, {
    path: "/login",
    component: _5134aebe,
    name: "login"
  }, {
    path: "/market-data",
    component: _ec1eb020,
    name: "market-data"
  }, {
    path: "/messages",
    component: _2446f0a6,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _393b7026,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _7dbdcc85,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _df105d4a,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _07d6fda6,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _3f242090,
    name: "offers"
  }, {
    path: "/privacy",
    component: _55dc919d,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _a8f56bea,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _3bd29780,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _487512a9,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _8b566958,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _321ffaee,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _0e94e4df,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _112781f9,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _46688a50,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _06df7434,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _5212d29d,
    name: "users"
  }, {
    path: "/whoweare",
    component: _c2c871ae,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _6ebbae14,
    name: "why-bode"
  }, {
    path: "/admin/conversation",
    component: _9f237d38,
    name: "admin-conversation"
  }, {
    path: "/admin/offers",
    component: _6f7b69f8,
    name: "admin-offers"
  }, {
    path: "/admin/showings",
    component: _01ea4f6f,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _31e8680a,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _5c4abc38,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _4b2beafe,
    name: "login-reset"
  }, {
    path: "/offers/constants",
    component: _b7f9a9d2,
    name: "offers-constants"
  }, {
    path: "/offers/enums",
    component: _28919534,
    name: "offers-enums"
  }, {
    path: "/pro-edit/profile",
    component: _7ba52825,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _412af39e,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _e588801e,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _0e6e9c8c,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _30a8dcd1,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _1b1fdee8,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _550d35a1,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _d81b1ed2,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _425ef89c,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _68ddbe6a,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _76e2e64c,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _196434fe,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _5db398cf,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _493856a7,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _7b670426,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _2f994e04,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _94f78e6a,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _faa1e606,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _0966fdd2,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _3a626764,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _c7f91702,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _617fdfd4,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _5da1b3c1,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _218d5557,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _247e2b72,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _8d8e09e2,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _1f28ee72,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _37e2a1b7,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _855122f6,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _2248b157,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _4f088b00,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _418bef49,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _0866ff8f,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _24805ffb,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _32416526,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _d8ab2cd0,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _2ed39b27,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _37992f2e,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _c0529152,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _4f6eba07,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _69fa3600,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _15703738,
    name: "listings-id-submit-success"
  }, {
    path: "/offers/:id/agreement",
    component: _68aa64c4,
    name: "offers-id-agreement"
  }, {
    path: "/settings/:section?/enums",
    component: _c92e91b6,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _d6068062,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _ae6971ac,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _13a45b3a,
    name: "users-id-section"
  }, {
    path: "/",
    component: _e3b3e538,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
